import { Mesh, MeshBasicMaterial, VideoTexture } from "three";
export class AvatarHead {
    set userImage(value) {
        this._userImage = value;
        if (this.headMesh) {
            this.applyUserImageToScreen(this._userImage);
        }
    }
    set userVideoElement(value) {
        this.destroyVideoTexture();
        this._userVideoElement = value;
        if (value) {
            this.videoTexture = new VideoTexture(value);
        }
        if (this.headMesh && this._userVideoElement) {
            this.applyVideoTexture();
        }
    }
    constructor(mainGroup) {
        this.mainGroup = mainGroup;
        this.isHairVisibled = true;
        this.visible = true;
    }
    setVisible(visibility) {
        this.visible = visibility;
        if (this.headMesh) {
            this.headMesh.visible = visibility;
        }
    }
    setVideoTexture(texture) {
        this.videoTexture = texture;
        this.applyVideoTexture();
    }
    setHairVisibility(visible) {
        this.isHairVisibled = visible;
        const obj = this.mainGroup.getObjectByName("Hair");
        if (!obj)
            return;
        obj.visible = visible;
    }
    getMesh() {
        return this.headMesh;
    }
    destroyVideoTexture() {
        if (this._userVideoElement) {
            this._userVideoElement = undefined;
        }
        if (this.videoTexture) {
            this.videoTexture.dispose();
            this.videoTexture = undefined;
        }
        // Make sure the video texture is removed from the screen and reset to the user image
        this.applyVideoTexture();
    }
    destroy() {
        this.removeHeadMesh();
        this.destroyVideoTexture();
    }
    removeHeadMesh() {
        if (!this.headMesh)
            return;
        this.mainGroup.remove(this.headMesh);
        this.headMesh = undefined;
    }
    /**
     * Does the settings for the avatar-head-mesh and adds it to
     * this.mainGroup.
     * Todo: Use a setter-structure like for the other variables?
     */
    addMesh(headMesh) {
        this.removeHeadMesh();
        this.headMesh = headMesh;
        headMesh.traverse((object) => {
            object.receiveShadow = false;
            object.castShadow = false;
            // if the VirtualPlatform is scaled, frustum culling may cull
            // models that are still visible, so we have to disabel it.
            object.frustumCulled = false;
            object.matrixAutoUpdate = false;
        });
        headMesh.position.setScalar(0);
        headMesh.rotation.set(0, 0, 0);
        headMesh.updateMatrix();
        headMesh.visible = this.visible;
        this.mainGroup.add(headMesh);
        this.setHairVisibility(this.isHairVisibled);
        if (this._userVideoElement != undefined) {
            this.applyVideoTexture();
        }
        if (this.videoTexture !== undefined) {
            this.applyVideoTexture();
        }
        else if (this._userImage != undefined) {
            this.applyUserImageToScreen(this._userImage);
        }
    }
    applyVideoTexture() {
        if (!this.videoTexture) {
            if (this._userImage) {
                this.applyUserImageToScreen(this._userImage);
            }
            return;
        }
        const screen = this.mainGroup.getObjectByName("MonitorScreen");
        if (screen !== undefined && screen instanceof Mesh && screen.material instanceof MeshBasicMaterial) {
            screen.material.map = this.videoTexture;
            screen.material.needsUpdate = true;
        }
    }
    applyUserImageToScreen(texture) {
        if (this.videoTexture)
            return;
        const screen = this.mainGroup.getObjectByName("MonitorScreen");
        if (screen !== undefined && screen instanceof Mesh && screen.material instanceof MeshBasicMaterial) {
            screen.material.map = texture;
        }
    }
}
